import { useEffect, useState } from "react";
import axiosInstance from "../config/axiosInstance";
import { useCompany } from "../hooks/useCompany";
import { extractList } from "../utils/api";
import TagPicker from "../components/TagPicker";

const SegmentationPage = () => {
  const { company } = useCompany();
  const [categories, setCategories] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [searchCategories, setSearchCategories] = useState("");
  const [searchRegions, setSearchRegions] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const [categoriesResponse, regionsResponse] = await Promise.all([
        axiosInstance.get("/categories", { params: { itemsPerPage: -1 } }),
        axiosInstance.get("/regions", { params: { itemsPerPage: -1 } }),
      ]);
      const categoriesList = extractList(categoriesResponse).map((item) => ({
        id: item.id,
        label: item.nome,
      }));
      const regionsList = extractList(regionsResponse).map((item) => ({
        id: item.id,
        label: `${item.stateCode}${item.city ? " - " + item.city : ""}`,
      }));
      setCategories(categoriesList);
      setRegions(regionsList);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchSelected = async () => {
      if (!company?.id) return;
      const [companyCategories, companyRegions] = await Promise.all([
        axiosInstance.get(`/companies/${company.id}/categories`),
        axiosInstance.get(`/companies/${company.id}/regions`),
      ]);
      setSelectedCategories(
        (companyCategories.data.data || []).map((item) => item.categoryId)
      );
      setSelectedRegions(
        (companyRegions.data.data || []).map((item) => item.regionId)
      );
    };

    fetchSelected();
  }, [company?.id]);

  const toggleCategory = (id) => {
    setSelectedCategories((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const toggleRegion = (id) => {
    setSelectedRegions((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSave = async () => {
    if (!company?.id) return;
    setMessage("");
    try {
      await axiosInstance.put(`/companies/${company.id}/categories`, {
        categoryIds: selectedCategories,
      });
      await axiosInstance.put(`/companies/${company.id}/regions`, {
        regionIds: selectedRegions,
      });
      setMessage("Segmentação atualizada com sucesso.");
    } catch (error) {
      setMessage("Não foi possível salvar a segmentação.");
    }
  };

  if (!company?.id) {
    return <div className="card card--outlined">Cadastre sua empresa antes de segmentar.</div>;
  }

  return (
    <div className="fade-in page-stack">
      <div className="page-header">
        <div>
          <h2>Segmentação do anúncio</h2>
          <p>Selecione categorias e regiões para direcionar seus anúncios.</p>
        </div>
      </div>

      <div className="split">
        <TagPicker
          items={categories}
          selectedIds={selectedCategories}
          onToggle={toggleCategory}
          search={searchCategories}
          onSearchChange={setSearchCategories}
          emptyLabel="Nenhuma categoria encontrada."
        />
        <TagPicker
          items={regions}
          selectedIds={selectedRegions}
          onToggle={toggleRegion}
          search={searchRegions}
          onSearchChange={setSearchRegions}
          emptyLabel="Nenhuma região encontrada."
        />
      </div>

      {message ? <div className="alert">{message}</div> : null}
      <button className="button button--primary" onClick={handleSave}>
        Salvar segmentação
      </button>
    </div>
  );
};

export default SegmentationPage;
